'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _common = require('./common');

exports.default = (0, _common.withParams)({ type: 'required' }, _common.req);


//////////////////
// WEBPACK FOOTER
// ./~/vuelidate/lib/validators/required.js
// module id = 1127
// module chunks = 1